import { Mutex } from "async-mutex";

/**
 * These enums should be moved outside of video-sdk
 */
export enum ConsentStatus {
  UNKNOWN = "UNKNOWN", // When the consent status has not been fetched
  UNDECIDED = "UNDECIDED", // When the participant has not yet opted in or out
  DECIDING = "DECIDING", // When the provider prompts the patient to consent
  OPTED_OUT = "OPTED_OUT", // When the participant has explicity declined consent
  OPTED_IN = "OPTED_IN", // When the participant has consented
  SOFT_NO = "SOFT_NO", // When the participant has declined consent in-session (not recorded in BE)
}

export enum AudioRecordingState {
  RECORDING = "RECORDING",
  NOT_RECORDING = "NOT_RECORDING",
  DISABLED = "DISABLED",
}

/**
 * Mutex to ensure that only one operation that controls the audio recording is
 * happening at a time e.g. starting, stopping, and resetting the audio
 * recorder.
 */
export const controlAudioRecordingMutex = new Mutex();

/**
 * The source of the consent update.
 * Please add new sources to the iOS-repo enum as well to maintain proper data track parsing.
 * TODO ENGAGE-1391 - develops a strategy for handling server-side enum/constant updates in iOS.
 */
export enum ConsentUpdateSource {
  UNKNOWN = "unknown",
  TELEHEALTH = "telehealth",
  TELEHEALTH_WAITING_ROOM = "telehealth_waiting_room",
  PROVIDER_DASHBOARD = "provider_dashboard",
  CLIENT_PORTAL = "client_portal",
  INTAKE_PAPERWORK = "intake_paperwork",
  CHECKIN_PAPERWORK = "checkin_paperwork",
}

export enum DataChannelMessageType {
  APP_STATE = "APP_STATE",
  WHITEBOARD_UPDATE = "WHITEBOARD_UPDATE",
  WHITEBOARD_SNAPSHOT = "WHITEBOARD_SNAPSHOT",
  REFLECTION_TOPIC_UPDATE = "REFLECTION_TOPIC_UPDATE",
  RESTART_SESSION = "RESTART_SESSION",
}

export enum DataChannelUpdateStatus {
  NO_UPDATE_NEEDED = "NO_UPDATE_NEEDED",
  VALUE_AND_LAST_UPDATED_CHANGED = "VALUE_AND_LAST_UPDATED_CHANGED",
  LAST_UPDATED_CHANGED = "LAST_UPDATED_CHANGED",
}
